import * as partition from 'lodash/partition';
import * as startsWith from 'lodash/startsWith';

import { ApiParams } from './api-param.model';

export class WdsApiParamsBuilder {
	private finalApiParams: ApiParams[] = [];
	public filters: ApiParams[] = [];
	public includeChildren: ApiParams;

	public build(): ApiParams[] {
		// Merge filter params
		const apiParams: ApiParams[][] = partition(this.filters, ['paramId', 'filter']);
		const filterApiParam: ApiParams[] = apiParams[0];
		this.finalApiParams.push(this.mergeApiParams(filterApiParam));

		// Create IncludeChildren param
		if (this.includeChildren) {
			this.finalApiParams.push(this.includeChildren);
		}

		return this.finalApiParams;
	}

	private mergeApiParams(apiParams: ApiParams[]): ApiParams {
		const allValues: string[] = apiParams.map(apiParam => apiParam.value);
		const buckets = {};
		const finalAttributeValues: string[] = [];

		// Collect multiple of the same attributes
		const keyValuePairs = allValues.map(apiParam => apiParam.split(':'));

		keyValuePairs.forEach(keyValueFilter => {
			const oldValues = buckets[keyValueFilter[0]] || [];
			buckets[keyValueFilter[0]] = [...oldValues, keyValueFilter[1]];
		});

		// Combine multiple of the same attributes if needed
		Object.entries(buckets).forEach(([key, value]: [string, string[]]) => {
			let combinedValue = value[0];

			if (value.length > 1) {
				const orValues = value.join(' ');
				combinedValue = '(' + orValues + ')';
			}

			combinedValue = key + ':' + combinedValue;
			finalAttributeValues.push(combinedValue);
		});

		// Append the negation attributes to the end of the value as they break the request if passed in the middle
		const splitNegatedAttributes = partition(finalAttributeValues, attribute => startsWith(attribute, '-'));
		const finalValue = [splitNegatedAttributes[1].join(' AND '), splitNegatedAttributes[0].join(' AND ')].filter(args => !!args).join(' AND ');

		// Create the final apiParam
		const result = { paramId: apiParams[0].paramId, value: finalValue, type: apiParams[0].type };

		return result;
	}
}
